// Modelo Dinamico para monitoreo.

//TIPO 0: Solo LABEL
//{valor:"", descripcion:"", tipo:0 ,label:"g. Exposiciones en trabajos anteriores (ver HCU):",label2:"Tipo Detalle"},

//TIPO 1: select con opciones
//{valor:"", descripcion:"", tipo:1 ,label:"a. Datos de filiación:" ,data:["SI","NO"]},

//TIPO 2: Select con opciones y un campo con descripcion
//{valor:"", descripcion:"", valor2:"", tipo:2 ,label:"Discoteca:",data:["SI","NO"],label2:"veces/mes"},

//TIPO 3: Campo para observaciones inputText
//{valor:"", descripcion:"", tipo:3 ,label:"Valor:"},

//TIPO 4: Campo para observaciones textArea
//{valor:"", descripcion:"", tipo:4 ,label:"Valor:"},

export default class MonitoreoRespiratorioCuestionario16 {
    fecha={}
    lista=[
        {
            encabezado:"Datos de filiación",
            datos:[
                {valor:"", descripcion:"", tipo:21 ,label:"      C.I.: 1721930442", bold:false},
                {valor:"", descripcion:"", tipo:22 ,label:"      Edad: 32", bold:false},
                {valor:"", descripcion:"", tipo:23 ,label:"      Apellidos y nombres: LOPEZ CRISTIAN", bold:false},
                {valor:"", descripcion:"", tipo:24 ,label:"      Empresa: PRIVADOS", bold:false},
                {valor:"", descripcion:"", tipo:25 ,label:"      Puesto de trabajo: PRIVADO", bold:false},
            ]
        },
        {
            encabezado:"CUESTIONARIO 16, INSTRUMENTO DE APLICACIÓN",
            datos:[
                {valor:"", descripcion:"", tipo:1 ,label:"1. ¿Es olvidadizo (a)?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"2. ¿Le han dicho sus familiares y/o sus amigos que es olvidadizo(a)?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"3. ¿A menudo se olvida realizar actividades que considera importantes?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"4. ¿Le es difícil entender las noticias, programas o novelas que pasan por la radio o la televisión?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"5. ¿Tiene a menudo dificultades para concentrarse?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"6. ¿Se siente a menudo enojado(a) sin motivo?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"7. ¿Se siente a menudo abatido(a) o triste sin motivo?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"8. ¿Le cuesta decidirse a realizar actividades que usted sabe que debe realizar?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"9. ¿Se siente anormalmente cansado(a)?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"10. ¿Siente a veces como una presión en el pecho?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"11. ¿Ha sentido de pronto como que se va a caer al estar de pie o caminando?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"12. ¿Siente usted a menudo punzadas dolorosas, adormecimiento u hormigueo en alguna parte del cuerpo?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"13. ¿Le resulta difícil abrocharse los botones?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"14. ¿Siente que ha perdido fuerza en sus brazos o en sus piernas?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"15. ¿Ahora siente menos que antes en sus manos o en sus pies?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:1 ,label:"16. ¿A menudo se despierta, y luego se le hace difícil volver a dormir?" ,data:["SI","NO"]},
                {valor:"", descripcion:"", tipo:5 ,label:"CALCULAR", click:1 },
                {valor:"", descripcion:"", tipo:3 ,label:"PUNTAJE" }
            ]
        },
    ]
}
var today = new Date();
var dd = today.getDate();
var mm = today.getMonth() + 1; //January is 0!

var yyyy = today.getFullYear();
if (dd < 10) {
    dd = '0' + dd;
}
if (mm < 10) {
    mm = '0' + mm;
}
var today = dd + '/' + mm + '/' + yyyy;





// WEBPACK FOOTER //
// ./src/model/MonitoreoSaludMentalCuestionario16.js